<template>
    <b-modal
        ref="modalDelete"
        lazy
        title-tag="h2"
        :title="title"
        ok-title="Proceed"
        footer-class="d-flex"
    >
        <span>
            <LoaderCustom
                v-if="isLoadingWarningMessage"
                :rowCount="2"
            ></LoaderCustom>
            <b-alert v-else variant="warning" show>
                Warning: {{ warningMessage }}
            </b-alert>
            <hr />
            <label class="font-weight-normal" for="confirmation">
                Please type
                <code class="px-2">{{ confirmationText }}</code> in the box
                below and click continue if you wish to proceed with the
                deletion of
                <strong class="font-italic">{{ templateName }}</strong
                >.
            </label>
        </span>

        <input-confirmation
            style="margin-top: 1rem;"
            ref="inputConfirmation"
            :confirmation-text="confirmationText"
            @is-matched="isMatched => (isConfirmationTextMatch = isMatched)"
        />

        <template v-slot:modal-footer="{ close }">
            <loader v-if="isLoading" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="close"
                v-if="!isLoading"
            >
                Cancel
            </b-button>

            <b-button
                v-if="!isLoading"
                variant="primary"
                :disabled="!enableDeleteButton"
                @click="proceed"
            >
                Delete
            </b-button>
        </template>
    </b-modal>
</template>

<script type="text/javascript">
import Loader from "@/module/commons/loader";
import TemplateService from "@/services/templates";
import InputConfirmation from "@/module/commons/input-confirmation";
import TEMPLATES from "@/constants/templates";
import LoaderCustom from "@/components/elements/loader-custom";
/**
 * This component previously been deleted and replaced by modal-delete-template-new by rename it to this. The deletion of previous componet was because of it only to handle delete form and this new component can handle delete all template types
 */
export default {
    components: {
        Loader,
        InputConfirmation,
        LoaderCustom
    },
    props: {},
    computed: {
        enableDeleteButton() {
            return this.isConfirmationTextMatch;
        },
        confirmationText() {
            if (this.isLoaded) {
                // Intead of "delete {type}" use "delete template" to avoid user to write down the confirmation too long like "delete purchase order"
                return "delete";
            }
            return "";
        },
        title() {
            return this.isLoaded ? `Delete ${this.templateTypeString}` : "";
        },
        templateTypeString() {
            if (this.template && this.template.template_type) {
                return this.template.template_type.value;
            }

            return TEMPLATES.LIST[this.template.type]?.label ?? "";
        },
        templateName() {
            return this.isLoaded ? this.template.name : "";
        },
        isLoaded() {
            return (
                this.template &&
                Object.values(TEMPLATES.TYPE).includes(
                    parseInt(this.template.type)
                ) &&
                this.template.type != 0
            );
        }
    },
    data() {
        return {
            TEMPLATES,
            template: null,
            isLoading: false,
            isLoadingWarningMessage: false,
            isConfirmationTextMatch: false,
            warningMessage: ""
        };
    },
    methods: {
        open(template) {
            this.template = template;
            this.checkConfirmToDelete();
            if (this.isLoaded) {
                this.$refs.modalDelete.show();
            }
        },
        async checkConfirmToDelete() {
            try {
                this.isLoadingWarningMessage = true;

                const res = await TemplateService.getDeleteMessage(
                    this.template.id
                );

                if (res) {
                    this.warningMessage = res.message;
                } else {
                    throw new Error(res);
                }
            } catch (error) {
                console.error(error.message);
                this._message(
                    "Error: Unable to retrieve delete confirmation message",
                    "danger"
                );
            } finally {
                this.isLoadingWarningMessage = false;
            }
        },
        async proceed() {
            try {
                const isConfirmationValid = this.$refs.inputConfirmation.isValid();
                if (!isConfirmationValid) {
                    return false;
                }

                this.isLoading = true;

                const res = await TemplateService.delete(this.template.id);

                if (res) {
                    this.isLoading = false;
                    this._message("Template deleted.");
                    this.$refs.modalDelete.hide();
                    this.$emit("onsuccess");
                } else {
                    throw new Error("error");
                }
            } catch (error) {
                this.isLoading = false;
                console.error(error.message);
                this._message("Error: Unable to delete template", "danger");
            }
        }
    }
};
</script>
